let SECOND_PLUS_CODES=[
  '1-0001','1-0015','1-0019','1-0042','1-0064','1-0183','1-0190','1-0191','1-0196',
  '1-0204','1-0218','1-0219','1-0220','1-0241','1-0245','1-0248','1-0249','1-0332',
  '1-0045','1-0020','1-0493','3-0001','3-0003','3-0004','3-0025','5-0001','5-0032',
  '5-0033','5-0013','4-0015','4-0056','6-0001','6-0002','6-0003','6-0043','9-0001',
  '9-0024','11-0001','11-0007','11-0027','7-0001','7-0002','7-0059','2-0002','2-0052',
  '2-0063','2-0064','2-0065','2-0068','2-0122','8-0003','10-0005','10-0007',
  '1-0276',
  '1-04007',
  '2-0079'
];
let SET={};
for(let i=0;i<SECOND_PLUS_CODES.length;i++){
  SET[SECOND_PLUS_CODES[i]]=true;
}
function isSecondPlus(code){
  return SET[String(code).trim()]===true;
}
export default {
  isSecondPlus: isSecondPlus
}



// WEBPACK FOOTER //
// ./src/view/hospitalGrade.js